var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currMemberDesc)?_c('span',{staticClass:"plan-joined-member-bar ym-mw-component-fixed-max",class:{ 'switch': _vm.isSwitching }},[_vm._v("\n  "+_vm._s(_vm.currMemberDesc)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }